module.exports = __webpack_public_path__ + "img/logo.5fb9bbd5.svg";